import { NominationScrubbingStatus } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryAwardNominationScrubbingStatus: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<NominationScrubbingStatus> = (fetchContext, programId, countryId, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/scrubbing-status`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationScrubbingStatus>(fetchContext.errorStore, response, 'get country award nomination scrubbing status'));
